import { Form } from "react-bootstrap";

// hooks
import { useEffect, useState } from "react";

// services (http request)
import getDatos from "../../../services/getDatos";

export default function Tipo({
  idComponente,
  handleChange,
  nameCombo,
  idTipo,
}) {
  const [tipo, setTipo] = useState();
  useEffect(() => {
    async function aux() {
      const data = await getDatos("atributos/combos");
      const tipos = data?.resultTipo.filter(
        (tipo) => tipo.fk_id_componente === idComponente
      );
      setTipo(tipos);
    }

    aux();
  }, []);
  return (
    <>
      <Form.Select
        className="inputs-forms-admin focus-admin-register"
        onChange={(e) => {
          handleChange(e, nameCombo);
        }}
        name={nameCombo}
        value={idTipo}
      >
        <option selected>Seleccione...</option>
        {tipo
          ? tipo.map((e, i) => {
              return (
                <option key={e.id_tipo} value={e.id_tipo}>
                  {e.nombre}
                </option>
              );
            })
          : ""}
      </Form.Select>
    </>
  );
}
